// hooks/requests/t2pay/use-get-account-balance.ts

import useSWR from "swr";

import SWR_KEYS from "@/constants/swr-keys";
import { AccountBalance } from "@/interfaces/talk2pay.iterfaces";
import t2payService from "@/services/t2pay.service";
import { RequestsBaseReturn } from "@/types/requests.types";

export type UseGetAccountBalanceReturn = RequestsBaseReturn<AccountBalance | null>;

const useGetAccountBalance = (): UseGetAccountBalanceReturn => {
  const fetcher = useSWR<AccountBalance, Error>(
    SWR_KEYS.getAccountBalance,
    () => t2payService.getAccountBalance(),
    { revalidateOnFocus: false }
  );

  const { data = null, isValidating: isLoading, error } = fetcher;

  return { data, isLoading, error };
};

export default useGetAccountBalance;
